import React, { useEffect, useState } from "react";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";
import DailyFloodReportStatusForm from "./DailyHeatWaveReportStatusForm";
import moment from "moment";
import DailyColdWaveReportStatusForm from "./DailyHeatWaveReportStatusForm";
import DailyHeatWaveReportStatusForm from "./DailyHeatWaveReportStatusForm";
//import DMSHeader from "../../DMSHeader/DMSHeader";

const DailyHeatWaveReportStatus = () => {
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  useEffect(() => {
    GridStack.init();
  }, []);
  const coldWaveReportStatusfile = `DailyColdWaveReportStatus_${selectedDate}`;
  console.log("filename in reprotstatus=====", coldWaveReportStatusfile);

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title="Heat Wave Daily Report Status"
          fileName={`DailyHeatWaveReportStatus`}
          showdownload={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 10,
      id: 2,
      component: (
        <DailyHeatWaveReportStatusForm
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
        />
      ),
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default DailyHeatWaveReportStatus;
